import moment, { Moment } from 'moment';

export enum DateDiffTypes {
  days = 'days',
  months = 'months',
}

export function formatDateForDb(date) {
  // SHOULD BE DEPREACTED - please use another function:
  // - to format string date to a YYYY-MM-DD format use formatDateFromString
  // - to format date to a YYYY-MM-DD format use formatDate
  return moment(date).format('YYYY-MM-DD');
}

export function formatDate(date: Moment): string {
  return date.format('YYYY-MM-DD');
}

export function getDateObjectFromString(date: string): Moment {
  return moment.utc(date);
}

export function formatDateFromString(date: string): string {
  return formatDate(getDateObjectFromString(date));
}

export function daysDiff(start, end) {
  return moment.utc(end).diff(moment.utc(start), 'days');
}

export function formatDateForDisplay(
  date: string | Moment,
  shortened: boolean = true,
) {
  return moment(date).format(shortened ? 'MMM D, YYYY' : 'MMMM D, YYYY');
}

export function dateDifference(
  date1: Moment,
  date2: Moment,
  type: DateDiffTypes = DateDiffTypes.days,
) {
  let diff = date1.diff(date2, type, true);
  diff = Math.round(diff);
  return diff > 0 ? diff : diff * -1;
}
